import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  //
  // life cycle
  //
  initialize() {
    $("body").on("click", ".article-body__reference-to", (e) => {
      this.scroll(e);
    });
  }

  get data() {
    return {
      targetClass: ".article-body__reference-from",
      overflowContainer: "[data-target='componentScrollToReference.overflowContainer']"
    };
  }

  scroll(e) {
    const $clickedObject = $(e.target);
    const clickHeight = $clickedObject.offset().top;
    let $targetObject = null;
    $(this.data.targetClass).each((index, element) => {
      if ($(element).offset().top > clickHeight && $targetObject == null){
        $targetObject = $(element);
      }
    });
    window.helpers.scrollTo.goInOverflowScroll($targetObject, $(this.data.overflowContainer), 60);
  }
}


